import CryptoJS from "crypto-js"

// 32 字节密钥的 Base64（前后端必须一致）
const PASSPHRASE = "mySuperSecretPassphrase!2024"

/**
 * 前端加密密码
 * @param {string} plainPassword 明文
 * @returns {string} Base64 密文（IV + 密文）
 */
export function encrypt(plainPassword) {
    try {
        // 1. 用 SHA-256 派生 32 字节密钥
        const key = CryptoJS.SHA256(PASSPHRASE) // 固定 32 字节

        // 2. 生成 16 字节随机 IV
        const iv = CryptoJS.lib.WordArray.random(16)

        // 3. AES-256-CBC 加密
        const encrypted = CryptoJS.AES.encrypt(plainPassword, key, {
            iv: iv,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7
        })

        // 4. IV + 密文 → Base64
        const combined = iv.concat(encrypted.ciphertext)
        return CryptoJS.enc.Base64.stringify(combined)
    } catch (e) {
        console.error("加密失败", e)
        return null
    }
}
